let mapsLoader = null;

function loadGoogleMaps(apiKey) {
    if (mapsLoader) return mapsLoader;

    mapsLoader = new Promise((resolve) => {
        if (window.google && window.google.maps) {
            resolve(window.google);
            return;
        }

        const callbackName = '__googleMapsInit';
        window[callbackName] = () => resolve(window.google);

        const script = document.createElement('script');
        script.src = `https://maps.googleapis.com/maps/api/js?key=${encodeURIComponent(apiKey)}&callback=${callbackName}&loading=async`;
        script.async = true;
        script.defer = true;
        document.head.appendChild(script);
    });

    return mapsLoader;
}

class Map {
    constructor(passedElement) {
        let self = this;

        self.elem = passedElement;
        self.apiKey = self.elem.dataset.apiKey || '';
        self.pinSvg = self.elem.dataset.pinSvg || '';
        self.map = null;
    }

    init() {
        let self = this;

        if (!self.elem || !self.apiKey) return self;

        loadGoogleMaps(self.apiKey).then((google) => {
            self.render(google);
        });

        return self;
    }

    render(google) {
        let self = this;

        const centreParts = (self.elem.dataset.centre || '')
            .split(',')
            .map((v) => parseFloat(v));
        const markers = JSON.parse(self.elem.dataset.markers || '[]');

        const hasCentre = !isNaN(centreParts[0]) && !isNaN(centreParts[1]);
        const fallback = markers[0]
            ? { lat: parseFloat(markers[0].lat), lng: parseFloat(markers[0].lng) }
            : { lat: 0, lng: 0 };

        self.map = new google.maps.Map(self.elem, {
            center: hasCentre ? { lat: centreParts[0], lng: centreParts[1] } : fallback,
            zoom: 12,
            mapTypeControl: false,
            streetViewControl: false,
        });

        if (!markers.length) return;

        const icon = self.buildIcon(google);
        const bounds = new google.maps.LatLngBounds();
        const infoWindow = new google.maps.InfoWindow();

        markers.forEach((m) => {
            const position = { lat: parseFloat(m.lat), lng: parseFloat(m.lng) };
            const marker = new google.maps.Marker({
                position,
                map: self.map,
                title: m.title || '',
                icon,
            });
            bounds.extend(position);

            if (m.title || m.content) {
                marker.addListener('click', () => {
                    infoWindow.setContent(
                        '<div class="map__info">'
                            + (m.title ? `<h3 class="map__info-title">${m.title}</h3>` : '')
                            + (m.content ? `<div class="map__info-body">${m.content}</div>` : '')
                        + '</div>'
                    );
                    infoWindow.open(self.map, marker);
                });
            }
        });

        if (markers.length > 1 && !hasCentre) {
            self.map.fitBounds(bounds);
        }
    }

    buildIcon(google) {
        let self = this;

        if (!self.pinSvg) return undefined;

        const url = `data:image/svg+xml;charset=UTF-8,${encodeURIComponent(self.pinSvg)}`;

        return {
            url,
            scaledSize: new google.maps.Size(32, 42),
            anchor: new google.maps.Point(16, 41),
        };
    }
}

export default Map;
